<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {
            trackBy: 'id',

            channel: null,
            initChannel: [],
            channels_option: [],

            bot_channel: null,
            initBotChannel: [],
            bot_channels_option: [],
            
            provider: null,
            initProvider: [],
            providers_option: []
        }
    },

    watch: {
        initChannel: {
            immediate: true,
            handler(values) {
                this.channel = this.channels_option.filter(x => values.includes(x[this.trackBy]));
                this.channel = this.channel[0];
                if(this.channel && this.channel.code){
                    this.$parent.message_send.channel_code = this.channel.code;
                    this.get_providers(this.channel.code)
                } else {
                    this.$parent.message_send.channel_code = null;
                }
            }
        },
        initBotChannel: {
            immediate: true,
            handler(values) {
                this.bot_channel = this.bot_channels_option.filter(x => values.includes(x['uuid']));
                this.bot_channel = this.bot_channel[0];
                if(this.bot_channel && this.bot_channel.code){
                    this.$parent.message_send.channel_code = this.bot_channel.code;
                    this.$parent.message_send.bot_channel_uuid = this.bot_channel.uuid;
                    this.get_providers(this.bot_channel.code)
                } else {
                    this.$parent.message_send.channel_code = null;
                }
            }
        },
        bot_channel: {
            immediate: true,
            handler(values) {                
                this.bot_channel = values;
                if(this.bot_channel){
                    // console.log(values);
                    this.$parent.message_send.channel_code = values.channel_code;
                    this.$parent.message_send.bot_channel_uuid = values.uuid;
                    this.get_providers(values.channel_code)
                } else {
                    this.$parent.message_send.channel_code = null;
                }
            }
        },
        initProvider: {
            immediate: true,
            handler(values) {
                this.provider = this.providers_option.filter(x => values.includes(x['operator_uuid']));
                this.provider = this.provider[0];
            }
        },
        provider: {
            immediate: true,
            handler(values) {
                if(this.provider){
                    this.$parent.message_send.provider = this.provider.operator_code ? this.provider.operator_code : null;
                    this.$parent.message_send.provider_uuid = this.provider.operator_uuid ? this.provider.operator_uuid : null
                } else {
                    this.$parent.message_send.provider = null;
                    this.$parent.message_send.provider_uuid = null
                }
            }
        }
    },

    computed: {
        operators_tariffs_list_data(){
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_LIST_DATA'];
        },
        channels_list_data(){
            return this.$store.getters['channels/GET_CHANNELS_LIST_DATA'];
        },        
        bot_channels_list_data(){
            return this.$store.getters['botsChannels/GET_BOTS_CHANNELS_LIST_DATA'];
        }        
    },

    async mounted() {

        // await this.$store.dispatch('channels/FETCH_CHANNELS_LIST', {'status': 'active', 'filter': 'message_send', 'filterOn': JSON.stringify(['action_code'])});
        // this.channels_option = this.channels_list_data;

        if(this.$parent.bot_uuid !== null){
            await this.$store.dispatch('botsChannels/FETCH_BOTS_CHANNELS_LIST', {'filter': this.$parent.bot_uuid, 'filterOn': JSON.stringify(['bot_uuid'])});
            this.bot_channels_option = this.bot_channels_list_data;
            this.initBotChannel = [this.$parent.params.message_send.bot_channel_uuid];
        }

        if(this.bot_channel && this.bot_channel.product_code){
            this.get_providers(this.bot_channel.product_code)
        }
    },

    methods: {
        async get_providers(product_code) {
            let data_send = {
                'filter'     : product_code,
                'filterOn'   : JSON.stringify(['product_code']),
                'get_fields' : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
                'groupBy'    : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
            }

            await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);

            this.providers_option = this.operators_tariffs_list_data;

            if(this.$parent.params.message_send && this.$parent.params.message_send.provider_uuid) {
                this.initProvider = [this.$parent.params.message_send.provider_uuid];
            }
        }
    }
}
</script>

<template>
    <div>
        
        <b-form-group            
            label="Канал коммуникаций"
            label-for="bot_channel"
        >
            <multiselect
                id="bot_channel"
                v-model="bot_channel"
                :options="bot_channels_option"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="channel_name"
                :track-by="'uuid'"
            ></multiselect>
        </b-form-group>

        <b-form-group
            v-if="providers_option && providers_option.length && providers_option.length > 0"
            label="Провайдер"
            label-for="provider"
        >
            <multiselect
                id="provider"
                v-model="provider"
                :options="providers_option"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="operator_name"
                :track-by="'operator_uuid'"
            ></multiselect>
        </b-form-group>

        <b-form-group
            label="Номер телефона"
            label-for="message_send_phone"
        >
            <b-form-input
                id="message_send_phone"
                v-model="$parent.message_send.phone"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            label="Сообщение"
            label-for="text"
        >
            <b-form-textarea
                id="text"
                v-model="$parent.message_send.text"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

    </div>
</template>
